import DdiNumberView from './ddi-number-view'

export default [ DdiNumberView ]
